// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MenuSection_wrapper__lS5mO","dropdownWrapper":"MenuSection_dropdownWrapper__R1dHi"};